import { Grid, Heading, Layout } from '@design-systems/canvas-ui'

export const SectionHeader = ({ pageHeading }) => {
  return (
    <Layout.PageHeader>
      <div className="hc-pa-dense hc-pb-none">
        <Grid.Container spacing="dense">
          {pageHeading && (
            <Grid.Item>
              <Heading data-testid="sectionHeaderHeading" size={4}>
                {pageHeading}
              </Heading>
            </Grid.Item>
          )}
        </Grid.Container>
      </div>
    </Layout.PageHeader>
  )
}
